var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"width":"25%"}}),_c('div',{ref:"hello"},[_c('h4',{staticStyle:{"opacity":"0"}},[_vm._v("gsgsgsgsgsgsgsggs")]),_c('h4',[_vm._v("gsgsgsgsgsgsgsggs")])]),_c('img',{attrs:{"src":_vm.output}})])}
var staticRenderFns = []

export { render, staticRenderFns }